import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import Button from '@fuww/library/src/Button';
import Markdown from '../components/Markdown';
import markdown from '../data/marketplace/about.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';

const MarketplaceAboutPage = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    intl.formatMessage(messages.marketplace),
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['marketplace.about.title'])}
        description={intl.formatMessage(
          messages['marketplace.about.description'],
        )}
      />
      <StaticPageComponent
        content={(
          <>
            <Markdown markdown={markdown} allowHtml allowGfm />
            <LinkAndAnchor
              route="register-buyer"
              passHref
            >
              <div style={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                >
                  Sign up for free
                </Button>
              </div>
            </LinkAndAnchor>
          </>
        )}
        title={intl.formatMessage(messages['marketplace.about.title'])}
        subTitle="marketplace"
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

MarketplaceAboutPage.getLayout = (page: ReactElement) => (
  <Layout>{page}</Layout>
);

export default MarketplaceAboutPage;
